import type { ComponentType } from "react";
import { MapPin, Users, Building2, Package, Calendar, BookOpen, UtensilsCrossed, Sparkles, Dumbbell } from "lucide-react";

type IconColor = "blue" | "red" | "orange" | "green" | "purple" | "gray" | "sky" | "emerald" | "amber";

export const ENTITY_GROUP_LABELS: Record<
  string,
  { label: string; icon: ComponentType<{ className?: string }>; iconColor: IconColor }
> = {
  places:     { label: "Places",        icon: MapPin,          iconColor: "blue" },
  people:     { label: "People",        icon: Users,           iconColor: "sky" },
  brands:     { label: "Brands",        icon: Building2,       iconColor: "gray" },
  products:   { label: "Products",      icon: Package,         iconColor: "purple" },
  events:     { label: "Events",        icon: Calendar,        iconColor: "red" },
  recipes:    { label: "Recipes",       icon: UtensilsCrossed, iconColor: "orange" },
  workouts:   { label: "Workouts",      icon: Dumbbell,        iconColor: "green" },
  creative:   { label: "Creative Work", icon: BookOpen,        iconColor: "emerald" },
  other:      { label: "Other",         icon: Sparkles,        iconColor: "amber" },
};

/** Maps API routing_class values to the entity group key used by ENTITY_GROUP_LABELS. */
export const ROUTING_CLASS_TO_GROUP: Record<string, string> = {
  Place: "places",
  GeoArea: "places",
  PersonOrgBrand: "brands",
  Eventish: "events",
  CreativeWork: "creative",
  Recipe: "recipes",
  Workout: "workouts",
  Product: "products",
  Abstract: "other",
};
